import React from 'react'
import SeniorPortraitsReview from '../../senior-portraits-review'

const ElementaryMultiPoseReview = () => (
  <SeniorPortraitsReview isSenior={false} />
)

export default ElementaryMultiPoseReview
